export const pcWidth = 1440;
export const spWidth = 768;